import React from 'react';
import { Search, Filter, Download } from 'lucide-react';
import LotFilterPanel from './LotFilterPanel';
import type { LotFilter } from '../../types/lot';

interface LotFiltersProps {
  showExport?: boolean;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  isFilterOpen: boolean;
  onFilterToggle: () => void;
  filters: LotFilter;
  onFilterChange: (filters: Partial<LotFilter>) => void;
  communities: string[];
  zones: string[];
  leaseIds: string[];
  leaseholders?: string[];
  zoneDescriptions?: Record<string, string>;
}

export default function LotFilters({
  searchQuery,
  onSearchChange,
  isFilterOpen,
  onFilterToggle,
  filters,
  onFilterChange,
  communities,
  zones,
  leaseIds,
  leaseholders = [],
  showExport = true,
  zoneDescriptions = {}
}: LotFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto mb-4">
      <div className="relative flex-1 sm:flex-none">
        <input
          type="text"
          placeholder="Search lots..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
        />
        <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
      </div>
      <div className="relative flex-1 sm:flex-none">
        <button
          onClick={onFilterToggle}
          className="w-full sm:w-auto flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
        >
          <Filter className="h-5 w-5 mr-2" />
          Filters
          {Object.values(filters).filter(Boolean).length > 0 && (
            <span className="ml-2 bg-primary text-white text-xs rounded-full px-2 py-0.5">
              {Object.values(filters).filter(Boolean).length}
            </span>
          )}
        </button>
        <LotFilterPanel
          isOpen={isFilterOpen}
          onClose={onFilterToggle}
          filters={filters}
          onFilterChange={onFilterChange}
          communities={communities}
          zones={zones}
          leaseIds={leaseIds}
          leaseholders={leaseholders}
          zoneDescriptions={zoneDescriptions}
        />
      </div>
      {showExport && (
        <button className="flex-1 sm:flex-none flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
          <Download className="h-5 w-5 mr-2" />
          Export
        </button>
      )}
    </div>
  );
}
